<template>
  <div class="infoMessageMain">
    <div class="infoMessage">
        <span style="color:#df3333;margin-right: 5px;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" width="20" height="17"><path fill="currentColor" d="M18.2 12.1c-1.5-1.8-5-2.7-8.2-2.7s-6.7 1-8.2 2.7c-.7.8-.3 2.3.2 2.8.2.2.3.3.5.3 1.4 0 3.6-.7 3.6-.7.5-.2.8-.5.8-1v-1.3c.7-1.2 5.4-1.2 6.4-.1l.1.1v1.3c0 .2.1.4.2.6.1.2.3.3.5.4 0 0 2.2.7 3.6.7.2 0 1.4-2 .5-3.1zM5.4 3.2l4.7 4.6 5.8-5.7-.9-.8L10.1 6 6.4 2.3h2.5V1H4.1v4.8h1.3V3.2z"></path></svg>
        </span>
         {{ interpretedUnasweredCallMessage(message) }}
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'

export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  mixins: [messageMixin]
}
</script>

<style scoped>
.infoMessageMain {
  display: flex;
  justify-content: center;
}

.infoMessage {
  background-color: rgb(255, 251, 199);
  font-size: 11px;
  padding: 7px;
  border-radius: 5px;
  margin-bottom: 3px;
    display: flex;
    align-items: center;
}
</style>
